export const BOOKING_MAIL = "booking@raykschoerling.com";
export const KONTAKT_MAIL = "kontakt@raykschoerling.com";

export const LEGAL_ADDRESS = {
  street: "Berliner Allee 75",
  zip: "13088",
  city: "Berlin",
} as const;

export const PRAXIS_ADDRESSES = [
  { street: "Berliner Allee 75", zip: "13088", city: "Berlin" },
  { street: "Thälmannstraße 24", zip: "16515", city: "Oranienburg" },
] as const;

export const LEGAL_PHONE = "0176 87844598";
